export enum CANCEL_TYPE {
  CANCEL = 'CANCEL',
  PARTIAL_CANCEL = 'PARTIAL_CANCEL',
}

export enum VALIDATE_STATUS_TRADE {
  OKAY = '주문하기',
  CANCEL = '취소',
  INPUT = '주문 정보를 입력해주세요',
  COUNT = '수량을 초과했습니다.',
  SIGN_IN = '로그인을 해주세요!',
  BALANCE = '예치금이 부족합니다.',
  LIMIT_COUNT = '구매 가능 수량을 초과했습니다.',
  OWN_COUNT = '보유 수량을 초과했습니다.',
}

export enum VALIDATE_STATUS {
  OKAY,
  INPUT,
  CHECK,
}

export enum LOADING_STATUS {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  FAILED = 'FAILED',
  LOADED = 'LOADED',
}
